
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig", "isClienteNutsDireto"]),

    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    },

    showPdvShortcuts() {
      return ["vendasNovo", "vendasEditar"].includes(this.$route.name);
    },
  },
};
